import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetAllRoundActive = createAsyncThunk(
  "DropDowns/GetAllRoundActive",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDownsManager/GetAllRoundActive"
      );

      const data = response.data.result;
      console.log(data, "dataaaa");

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DropDownRoundActive = createSlice({
  name: "DropDownRoundActive",
  initialState: {
    DropDownRoundActive: [],
    loadingDropDownRoundActive: false,
    errorDropDownRoundActive: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllRoundActive.pending, (state, action) => {
        state.loadingDropDownRoundActive = true;
        state.DropDownRoundActive = action.payload;
        state.errorDropDownRoundActive = null;
      })
      .addCase(GetAllRoundActive.fulfilled, (state, action) => {
        state.loadingDropDownRoundActive = false;
        state.DropDownRoundActive = action.payload;
      })
      .addCase(GetAllRoundActive.rejected, (state, action) => {
        state.loadingDropDownRoundActive = false;
        state.errorDropDownRoundActive = action.payload;
      });
  },
});

export default DropDownRoundActive.reducer;
